import type { subscriptionCategorySchema } from '@tempo-io/notification-dto';
import { z } from 'zod';

export type NotificationCategory = z.infer<typeof subscriptionCategorySchema>;

export const UpdateNotificationSubscriptionsSchema = z.object({
  productAreaIds: z.array(z.number()),
});

export type UpdateNotificationSubscriptionsDto = z.infer<
  typeof UpdateNotificationSubscriptionsSchema
>;

export const NotificationSubscriptionResponseSchema = z.object({
  productAreaIds: z.array(z.number()),
});

export type NotificationSubscriptionResponseDto = z.infer<
  typeof NotificationSubscriptionResponseSchema
>;

export const GetTargetUsersQuerySchema = z.object({
  productAreaIds: z.array(z.number()).min(1, 'At least one product area ID is required'),
});

export type GetTargetUsersQueryDto = z.infer<typeof GetTargetUsersQuerySchema>;

export const GetTargetUsersResponseSchema = z.object({
  userIds: z.array(z.string()),
});

export type GetTargetUsersResponseDto = z.infer<typeof GetTargetUsersResponseSchema>;
